import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class CompanyLogo extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get pressRoomCategory() {
    return get(this, '_kategoria_press_room.value[0].codename', []);
  }

  get file() {
    return get(this, '_plik.value[0]', {});
  }
}



// WEBPACK FOOTER //
// ./src/models/CompanyLogo.model.js